import React, { FC, useCallback } from "react";
import { DialogWizardStep, DialogWizardStepProps } from "../../DialogComponents/DialogWizard/DialogWizardStep";
import { useContext } from "../hooks/useContext";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { AddProxyServiceWizardTitle } from "./AddProxyServiceWizardTitle";

export const AddProxyServiceWizardStep: FC<Omit<DialogWizardStepProps, "dialogContext">> = props => {
  const context = useContext();
  const { setStep } = useAddProxyServiceContext();
  const { extra, onNextStep, onPreviousStep } = props;

  const onNextWizardStep = useCallback(() => {
    onNextStep && onNextStep();
    setStep(currentStep => currentStep + 1);
  }, [onNextStep, setStep]);
  const onPreviousWizardStep = useCallback(() => {
    onPreviousStep && onPreviousStep();
    setStep(currentStep => currentStep - 1);
  }, [onPreviousStep, setStep]);

  return (
    <DialogWizardStep
      extra={extra || <AddProxyServiceWizardTitle />}
      dialogContext={context}
      {...props}
      onNextStep={onNextWizardStep}
      onPreviousStep={onPreviousWizardStep}
    />
  );
};
